import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Row, Col, FormGroup, Label, Input} from 'reactstrap';
import {TabelaCadastro} from "../components/TabelaCadastro";
import EmpresaGloboStore from "../stores/EmpresaGloboStore";
import {Validacao} from "../../comum/components/Validacao";
import NumberFormat from "react-number-format";

@inject("store")
@DataWrapper
@observer
export class CadastroEmpresaGlobo extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new EmpresaGloboStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Unidade de negócio (BU)");
        this.controller.carregarLista();
    }

    /* modais (body e botões) */
    modalForm = () => {
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                        <FormGroup>
                        <Label check>
                            <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()}/>{' '}
                            <Label>Ativo</Label>
                        </Label>
                        </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                    <Label>Nome <sup>*</sup></Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.nome} onChange={(event) => this.controller.setNome(event.target.value)} />
                    <Validacao id="nome" valor={this.controller.itemSelecionado.nome} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                    <Label>Código empresa <sup>*</sup></Label>
                        <Input type="text" maxLength={3} value={this.controller.itemSelecionado.codigoFpw} onChange={(event) => this.controller.setCodigoEmpresa(event.target.value)} />
                    <Validacao id="nome" valor={this.controller.itemSelecionado.codigoFpw} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Grupo salarial</Label>
                        <Input type="text" maxLength={16} value={this.controller.itemSelecionado.grupoSalarial} onChange={(event) => this.controller.setGrupoSalarial(event.target.value)} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Código BU <sup>*</sup></Label>
                        <Input type="text" maxLength={16} value={this.controller.itemSelecionado.codigoBu} onChange={(event) => this.controller.setCodigoBu(event.target.value)} />
                        <Validacao id="codigoBu" valor={this.controller.itemSelecionado.codigoBu} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Percentual de (ISS, PIS, COFINS e IR/CSLL) para cálculo de custo de MOT <sup>*</sup></Label>
                        <NumberFormat suffix="%" allowNegative={false} className="form-control" decimalPrecision={2} value={this.controller.itemSelecionado.percentualImpostoVR} onChange={(event, values) => this.controller.setPercentualImpostoVR(values.floatValue)}/>
                        {/*<Input type="text" decimalPrecision={2} value={this.controller.itemSelecionado.percentualImpostoVR} onChange={(event) => this.controller.setPercentualImpostoVR(event.target.value)} />*/}
                        <Validacao id="percentualImpostoVR" valor={this.controller.itemSelecionado.percentualImpostoVR} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>E-mail aprovador lote</Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.emailAprovadorLote} onChange={(event) => this.controller.setEmailAprovadorLote(event.target.value)} />
                    </FormGroup>
                </Col>
            </Row>
                //RHFPP-1548 - Consulta Custo Mot
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nome;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Grupo salarial: " + (objeto.grupoSalarial != null ? objeto.grupoSalarial : "")}<br/>
                { "Código BU: " + objeto.codigoBu}<br/>
            </div>
        )
    };

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "nome",
                label: "Nome"
            },
            {
                field: "grupoSalarial",
                label: "Grupo salarial"
            },
            {
                field: "codigoBu",
                label: "Código BU"
            },
            {
                field: 'percentualImpostoVR',
                label: 'Imposto p/ VR de MOT',
                type: "percentage"
            },
            {
                field: 'ativo',
                label: 'Ativo',
                type: 'boolean'
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Unidade de negócio (BU)'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.empresaGloboLista}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm()}
                            modalCadastrar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}